import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="print"
// Used in: school_show_timetables _share.html.erb
// Purpose: print
export default class extends Controller {
  print() {
    window.print();
  }
}
